import React from 'react';
import Grid from '@material-ui/core/Grid';
import {useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";


/////////////////////////////////////////////////////////////
/* 
Al hacer alguna modificacion aca verificar como queda:
    >Dashboard/widgets/Informacion
    >Dispositivos/Compartir
*/
////////////////////////////////////////////////////////////
const useStyles = makeStyles((theme) => ({
    tittle:{
        marginTop:"0px",
        marginBottom: "10px",
        minWidth: "200px",
        minHeight:"20px", 
        fontWeight: 250
    }
}));

export default function Titulo2 (props){
    const classes = useStyles();
    return (
        <>
        {props.titulo ?
            <>
                <h1 className={classes.tittle}>
                    {props.titulo}
                </h1>
            </>
        : 
        null }
        </>
    );
}

